module.exports = __webpack_public_path__ + "static/2018-10-30-PODCAST_Health_Maintenance_transcript-65f9d9958f7e2e5fbf7653189016cbb5.pdf";